const React = require('react');
const classNames = require('classnames');

class Spinner extends React.Component {
  classNames = () => {
    return classNames('loading-component', this.props.size);
  };

  getWings = () => {
    const wings = [];
    const wingCount = this.props.size == 'small' ? 3 : 5;
    const color = (this.props.color) ? { backgroundColor: this.props.color } : null;

    for (let i = 0; i < wingCount; i++) {
      let wing = {
        classNames: `rect rect${i + 1}`,
        style: color,
      };

      wings.push(wing);
    }

    return wings;
  };

  render() {

    return (
      <div className={this.classNames()}>
        {this.getWings().map((wing, index) => {
          return <div key={index} className={wing.classNames} style={wing.style} ></div>;
        })}
      </div>
    );
  }
}

module.exports = Spinner;



// WEBPACK FOOTER //
// ./javascripts/components/shared/spinner.jsx